import { EditCapacityOverrideComponent } from '../edit-capacity-override/edit-capacity-override.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Transport, CapacityHealthIndEnum, CapacityHealthDisplayTextEnum } from '../../models/capacity.model';
import { selectCurrentCapacity } from '../../../store/capacity/capacity.adapter';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Capacity } from '../../models/capacity.model';
import { CapacityState } from 'src/app/modules/store/capacity/capacity.reducer';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray} from '@angular/forms';

@Component({
  selector: 'app-capacity-override-card',
  templateUrl: './capacity-override-card.component.html',
  styleUrls: ['./capacity-override-card.component.scss']
})
export class CapacityOverrideCardComponent implements OnInit, OnDestroy {

  transportForm: UntypedFormGroup;
  selectedCapacity$: Observable<Capacity>;
  public CapacityHealthIndEnum = CapacityHealthIndEnum;
  public capacityHeathDisplayEnum = CapacityHealthDisplayTextEnum;
  subscriptions: Subscription[] = [];
  editCapacityDialogRef: MatDialogRef<EditCapacityOverrideComponent>;

  transportOptions: Transport[] = [
    { id: 1, name: 'Shuttle' },
    { id: 2, name: 'Rental' },
    { id: 3, name: 'Drop Off' },
    { id: 4, name: 'Wait' }
  ];
  constructor(private readonly dialog: MatDialog,
              private readonly capacityStore: Store<CapacityState>,
              private readonly formBuilder: UntypedFormBuilder) {
    this.transportForm = this.formBuilder.group({
      transportOptions: this.formBuilder.array([])
    });

    this.transportOptions.forEach(option => {
      (this.transportForm.get('transportOptions') as UntypedFormArray).push(this.formBuilder.control(false));
    });
  }

  ngOnInit() {
    this.selectedCapacity$ = this.capacityStore.select(selectCurrentCapacity);
    this.fillTransportOptions();
  }

  get transportOptionsArr() {
    return this.transportForm.get('transportOptions') as UntypedFormArray;
  }

  fillTransportOptions() {
    this.subscriptions.push(this.selectedCapacity$.subscribe(t => {
      if (t) {
        this.transportOptions.forEach((option, index) => {
          (this.transportForm.get('transportOptions') as UntypedFormArray).controls[index].setValue(!!t.transport.find(x => x.id === option.id));

        });
      }
    }));
  }

  editCapacity() {
    this.editCapacityDialogRef = this.dialog.open(EditCapacityOverrideComponent, {minWidth: '500px', panelClass: 'asp-modal-container'});
    this.subscriptions.push(this.editCapacityDialogRef.afterClosed().subscribe(t => {

    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

}
